"use client";

import { useRef, type ButtonHTMLAttributes, type ReactNode } from "react";
import { magneticMove, magneticReset } from "@/lib/animations";
import { cn } from "@/lib/utils";

interface MagneticButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  strength?: number;
}

export function MagneticButton({ children, className, strength = 0.35, ...props }: MagneticButtonProps) {
  const ref = useRef<HTMLButtonElement>(null);

  function handleMouseMove(e: React.MouseEvent<HTMLButtonElement>) {
    if (!ref.current) return;
    magneticMove(ref.current, e, strength);
  }

  function handleMouseLeave() {
    if (!ref.current) return;
    magneticReset(ref.current);
  }

  return (
    <button
      ref={ref}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      className={cn(
        "flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full border border-white/35 bg-white/5 text-paper backdrop-blur-md transition-colors duration-300 hover:border-amber hover:bg-amber hover:text-ink",
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
